import {render} from "@variocube/app-ui";
import * as React from "react";
import {createElement} from "react";
import {App} from "./App";

render(<App />);
